<div class="flex flex-col h-svh px-4 pb-6 pt-6 items-center">
  <div class="flex-1 flex flex-col items-center justify-center text-center gap-8 max-w-[610px] w-full">
    <img src="../../../../../assets/images/svg/cross-error.svg" class="w-[72px] h-auto" alt="" />
    <div class="flex flex-col gap-4">
      <p class="font-bold text-base text-secondary">{{ 'connection_attempt_has_failed' | translate }}</p>
      <p class="text-sm text-secondary">
        {{
          (displayCrossDeviceCopy ? 'you_can_close_and_resume_where_you_left' : 'you_can_close_this_tab')
            | translate
        }}
      </p>
    </div>
  </div>
  @if (displayCloseButton) {
    <button
      class="bg-primary font-bold text-secondary text-base h-12 rounded-full w-full max-w-[550px]"
      (click)="closeTab()"
    >
      {{ 'close_tab' | translate }}
    </button>
  }
</div>
